import React from 'react';
import ReactDOM from 'react-dom';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core';

function SubmitErrorDialog({emails, resolve}) {
  const handleClose = () => resolve();

  return (
    <Dialog open onClose={handleClose}>
      <DialogTitle>Erro ao salvar usuários</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" gutterBottom>
          Os seguintes e-mails já estão cadastrados:
        </Typography>
        <List dense>
          {emails.map((email, index) => (
            <ListItem key={index}>
              <ListItemText primary={email} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default function ShowSubmitError(emails) {
  return new Promise(resolve => {
    const div = document.createElement('div');
    document.body.appendChild(div);

    const cleanup = () => {
      ReactDOM.unmountComponentAtNode(div);
      div.remove();
    };

    const handleResolve = () => {
      cleanup();
      resolve();
    };

    ReactDOM.render(
      <SubmitErrorDialog emails={emails} resolve={handleResolve} />,
      div,
    );
  });
}
